<template>
  <div>
    <b-loading :is-full-page="false" :active="loading" />
    <div class="table-tool-icon-bar">
      <i class="fas fa-trash-alt icon-style" 
        @click="confirmDeletion()" 
        v-show="checkedRows && checkedRows.length > 0 && canDeleteImage" >
      </i>
      <button 
        @click="toggleSelectMode"
        :class="['select-mode-btn', selectMode ? 'active' : '']"
      >
        {{ selectMode ? 'Exit Select Mode' : 'Enter Select Mode' }}
      </button>
    </div>

    <image-list-component :prior="'row'" :caseId="caseId" :revision="revision" :checkedRows.sync="checkedRows" :selectMode.sync="selectMode" />
    
    <!-- class="button is-link"  -->
    <div v-if="canAddImage && isStrictProjectManager" class="floating-add-button" @click="addImageModal = true">
      <i class="fas fa-plus"></i>
    </div>
    <add-image-modal :active.sync="addImageModal" @addImage="refreshData" />
  </div>
</template>
  
<script>
import {ImageInstance, ImageInstanceCollection, TagCollection } from 'cytomine-client';
import {vendorFromFormat} from '@/utils/vendor';
import {get} from '@/utils/store-helpers';
import AddImageModal from '@/components/image/AddImageModal';
import ImageListComponent from './ImageListComponent.vue';

// import ImageName from '@/components/image/ImageName';
// import ImageThumbnail from '@/components/image/ImageThumbnail';

export default {
  name: 'project-image-list-component',
  components : {
    // ImageName,
    // ImageThumbnail,
    AddImageModal,
    ImageListComponent
  },
  props: {
    caseId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      
      availableVendors: [],

      selectMode: false,
      checkedRows: [],
      addImageModal: false,
      revision: 0,
    };
  },
  watch: {
    checkedRows(newVal) {
      console.log('선택된 항목:', newVal);
    }
  },
  computed:  {
    currentUser: get('currentUser/user'),
    configUI: get('currentProject/configUI'),
    project: get('currentProject/project'),
    shortTermToken: get('currentUser/shortTermToken'),
    managers: get('currentProject/managers'),
    isSuperAdmin() {
      return this.$store.getters['currentUser/isSuperAdmin'];
    },
    isStrictProjectManager() {
      if (!this.currentUser || !this.managers) return false;
      const isManager = this.managers.some(user => user.id === this.currentUser.id);
      return isManager || this.isSuperAdmin;
    },

    blindMode() {
      return this.project.blindMode;
    },
    canManageProject() {
      return this.$store.getters['currentProject/canManageProject'];
    },
    canAddImage() {
      return !this.currentUser.guestByNow && (this.canManageProject || !this.project.isReadOnly);
    },
    canDeleteImage() {
      return !this.currentUser.guestByNow && this.isStrictProjectManager;
    },
    imageNameNotif() {
      if (!this.checkedRows || this.checkedRows.length === 0) {
        return '';
      }
      const names = this.checkedRows.map(item =>
        this.blindMode ? item.blindedName : item.instanceFilename
      );
      const joined = names.map(n => `- ${n}`).join('<br>');
      return joined;
    },

    imageCollection() {
      let collection = new ImageInstanceCollection({
        filterKey: 'case',
        filterValue: this.caseId,
      });
      console.log('collection', collection);
      return collection;
    },

    currentWorklist() {
      return this.$store.getters['worklist/getCurrentWorklist'];
    },
  },
  methods: {
    toggleSelectMode() {
      this.selectMode = !this.selectMode;
      if (!this.selectMode) {
        this.checkedRows = [];
      }
    },
    async fetchFilters() {
      console.log('> ListImages');
      let stats = await new ImageInstanceCollection.fetchBounds({project: this.caseId});
      this.maxWidth = Math.max(100, stats.width.max);
      this.maxHeight = Math.max(100, stats.height.max);
      this.maxNbUserAnnotations = Math.max(100, stats.countImageAnnotations.max);
      this.maxNbReviewedAnnotations = Math.max(100, stats.countImageReviewedAnnotations.max);


      this.availableFormats = stats.format.list;

      stats.format.list.forEach(format => {
        let vendor = vendorFromFormat(format);
        let vendorFormatted = {
          value: vendor ? format : 'null',
          label: vendor ? vendor.name : this.$t('unknown')
        };

        if (!this.availableVendors.find(vendor => vendor.value === vendorFormatted.value)) {
          this.availableVendors.push(vendorFormatted);
        }
      });

      this.availableMagnifications = stats.magnification.list.map(m => {
        return {
          value: m || 'null',
          label: m || this.$t('unknown')
        };
      });
      // this.availableResolutions = stats.resolution.list.map(resolution => {
      //   return {
      //     value: resolution || 'null',
      //     label: resolution ? `${resolution.toFixed(3)} ${this.$t('um-per-pixel')}` : this.$t('unknown')
      //   };
      // });
    },
    async fetchTags() {
      this.availableTags = [{id: 'null', name: this.$t('no-tag')}, ...(await TagCollection.fetchAll()).array];
    },

    async refreshData() {
      try {
        // await Promise.all([
        //   this.fetchFilters(),
        // ]);
        this.revision++;
      }
      catch(error) {
        console.log(error);
        this.error = true;
      }
    },
    confirmDeletion() {
      this.$buefy.dialog.confirm({
        title: this.$t('delete-image'),
        message: this.$t('delete-image-confirmation-message', {imageName: this.imageNameNotif}),
        type: 'is-danger',
        confirmText: this.$t('button-confirm'),
        cancelText: this.$t('button-cancel'),
        onConfirm: this.deleteImage
      });
    },
    async deleteImage() {
      try {
        const deletePromises = this.checkedRows.map(checkedRow => {
          console.log('delete image : ', checkedRow.id);
          return ImageInstance.delete(checkedRow.id);
        });
        this.loading = true;
        await Promise.all(deletePromises);
        this.loading = false;

        this.$notify({
          type: 'success',
          text: this.$t('notif-success-image-deletion', {imageName: this.imageNameNotif})
        });
        this.$emit('delete');

        let updatedProject = this.project.clone();
        updatedProject.numberOfImages--;
        this.$store.dispatch('currentProject/updateProject', updatedProject);

        await this.refreshData();
        
        this.checkedRows = [];
      }
      catch(err) {
        console.log(err);
        this.$notify({
          type: 'error',
          text: this.$t('notif-error-image-deletion', {imageName: this.imageNameNotif})
        });
      }
      finally {
        this.loading = false;
      }
    },

  },
  async created() {
    await Promise.all([
      this.fetchFilters(),
      this.fetchTags(),
    ]);
    this.loading = false;
  },
};

</script>

<style scoped>
.select-mode-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background-color: #e0e0e0;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  margin: 0 5px;
}

.select-mode-btn:hover {
  background-color: #d0d0d0;
}

.select-mode-btn.active {
  background-color: #2ab6f2; /* 파란색으로 활성 표시 */
  color: #fff;
  box-shadow: 0 2px 3px rgba(0,0,0,0.2);
}

.floating-add-button {
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 80px;
  height: 80px;

  background-color: #009BDB;
  border-radius: 50%;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  cursor: pointer;
}

.floating-add-button i {
  color: #fff;
  font-size: 30px;
}

.table-tool-icon-bar {
  height: 40px;
  display: flex;
  /* justify-content: space-between; */
  justify-content: flex-end;
  align-items: center;
}

.icon-style {
  cursor: pointer;
  margin-right: 10px;
  padding: 10px;
}


/* 해당 컴포넌트 안에서만 지정하려면,
::v-deep(.b-table thead th) {
  font-size: 0.8rem;
} */
</style>
